import React from 'lib/react';
import {
  EVPaper,
  EVGrid,
  EVSkeleton,
} from 'lib/components';
import useMediaQuery from 'hooks/useMediaQuery';
import Links from 'features/orderSubmitted/components/Links.component';
import PitchEditorStyles from './PitchEditorStyles';

function PitchEditorLoader() {
  const classes = PitchEditorStyles();
  const isMobile = useMediaQuery(640);

  return (
    <EVPaper square={isMobile} className={classes.mainPaper}>
      <EVGrid className={classes.detailsMapGrid}>
        <EVGrid className={classes.detailsGrid}>
          <EVGrid className={classes.detailsHeader}>
            <EVSkeleton style={{ height: '30px', width: '139px', borderRadius: '6px' }} animation="wave" variant="rect" />
            <EVSkeleton style={{ height: '20px', width: '337px', borderRadius: '6px' }} animation="wave" variant="rect" />
          </EVGrid>
          <EVGrid container className={classes.detailsContent}>
            <EVGrid className={classes.detailsContentContainer}>
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
            </EVGrid>
            <EVGrid className={classes.detailsContentContainer}>
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
            </EVGrid>
            <EVGrid className={classes.detailsContentContainer}>
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
            </EVGrid>
            <EVGrid className={classes.detailsContentContainer}>
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
            </EVGrid>
            <EVGrid className={classes.detailsContentContainer}>
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
              <EVSkeleton style={{ height: '24px', width: '120px', borderRadius: '6px' }} animation="wave" variant="rect" />
            </EVGrid>
          </EVGrid>
        </EVGrid>
        <EVPaper className={classes.mapGrid} square={isMobile} elevation={0}>
          <EVSkeleton style={{ height: '100%', width: '100%', borderRadius: '6px' }} animation="wave" variant="rect" />
        </EVPaper>
      </EVGrid>
      <EVGrid className={classes.editPitchContainer}>
        <EVSkeleton
          className={classes.editPitchComponent}
          animation="wave"
          variant="rect"
        />
      </EVGrid>
      <EVGrid className={classes.linksAndBtn}>
        <Links />
        <EVSkeleton className={classes.saveReportLoaderBtn} animation="wave" variant="rect" />
      </EVGrid>
    </EVPaper>
  );
}

export default PitchEditorLoader;
